@use '@/scss/underscore' as _;

.container {
  display: flex;
  flex-direction: column;
  gap: _.unit(4);
  padding-bottom: _.unit(6);
}
